/**
 * Web shim for @react-native-async-storage/async-storage.
 * Webpack aliases the native package to this file for the web build so the
 * same storage API (getItem/setItem/removeItem/...) works on localStorage.
 */
const mem = new Map<string, string>();

function ls(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

const AsyncStorage = {
  async getItem(key: string): Promise<string | null> {
    const store = ls();
    if (store) return store.getItem(key);
    return mem.has(key) ? (mem.get(key) as string) : null;
  },
  async setItem(key: string, value: string): Promise<void> {
    const store = ls();
    if (store) store.setItem(key, value);
    else mem.set(key, value);
  },
  async removeItem(key: string): Promise<void> {
    const store = ls();
    if (store) store.removeItem(key);
    else mem.delete(key);
  },
  async multiRemove(keys: string[]): Promise<void> {
    await Promise.all(keys.map((k) => this.removeItem(k)));
  },
  async clear(): Promise<void> {
    const store = ls();
    if (store) store.clear();
    else mem.clear();
  },
};

export default AsyncStorage;
